export default __webpack_public_path__ + "static/media/CIA-Claim-Form.8c4da273.pdf";